<template>
  <vx-card title="Тарифы" class="vx-card_full-height tariffs-card">

    <div slot="actions">
      <div class="vx-col flex flex-wrap items-center">
        <div class="mb-2 mr-2">
          <datepicker
            v-model="selectedMonth"
            class="datepicker_small header-datepicker"
            format="MMMM yyyy"
            minimumView="month"
            maximumView="year"
          />
        </div>
        <div class="mb-2 mr-2" v-if="$can('rp.tariffs', 'write')">
          <vs-button type="border" class="tariff-header__button" @click="isGroupAddOpen = true">Добавить группу
          </vs-button>
        </div>
        <div class="mb-2" v-if="$can('rp.tariffs', 'write')">
          <vs-button type="border" class="tariff-header__button" @click="isTariffAddOpen = true">Добавить тариф
          </vs-button>
        </div>
      </div>
    </div>

    <HeatSeasonSettings />

    <div class="tariffs">
      <div class="tariffs__tabs">
        <TabsHeader :tabs="availableTypes" :on-change="onSelectApartmentType" :active="selectedApartmentType" />
      </div>

      <vs-table ref="table" :data="sortedGroups" v-if="!isLoading" class="tariffs-table" noDataText="Тарифы не найдены">
        <template slot="thead">
          <vs-th>Название</vs-th>
          <vs-th style="width: 1%; min-width: 180px">
            <div class="w-full text-center">Тип</div>
          </vs-th>
          <vs-th style="width: 1%" class="text-center">Значение</vs-th>
          <vs-th style="width: 1%; min-width: 80px" class="text-center">Ед. измерения</vs-th>
          <vs-th>
            <div class="text-center w-full">
              Расчет
            </div>
          </vs-th>
          <vs-th style="width: 1%;" class="text-center">
            <div style="min-width: 115px">
              Не выводить пустое значение
            </div>
          </vs-th>
          <vs-th style="width: 1%" class="text-center">Пени</vs-th>
          <vs-th style="width: 1%" class="text-center">Доп. условия</vs-th>
          <vs-th style="width: 1%; min-width: 80px" class="text-center">Позиция</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <template v-for="(tr, indextr) in data">
            <vs-tr :data="tr" :key="indextr" class="tariff-row tariffs-table__group-row">
              <vs-td>
                <!--                  <span class="tariff-row__name tariff-row__name&#45;&#45;hidden"-->
                <!--                        style="white-space: nowrap; overflow: hidden;">{{ tr.name }}</span>-->
                <span class="tariff-row__name">
                    {{ tr.name }}
                    <span v-if="$can('rp.debug', 'read')" class="font-medium">#{{ tr.id }}</span>
                  </span>
              </vs-td>
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td>
                  <span class="tariff-row__show-empty">
                    <input
                      type="text" :value="tr.position" :disabled="!$can('rp.tariffs', 'write')"
                      @keypress="$validateInput($event, 'uint')" @change="changeGroupPosition(tr, $event)"
                      @keydown.enter="changeGroupPosition(tr, $event)" class="tariff-row__position-input"
                    >
                  </span>
              </vs-td>
              <vs-td style="width: 1%">
                   <span
                     class="tariff-row__buttons" style="justify-content: flex-end"
                     v-if="$can('rp.tariffs', 'write')"
                   >
                      <feather-icon icon="SettingsIcon" @click="openEditGroup(tr)" />
                   </span>
              </vs-td>
            </vs-tr>
            <template v-if="tr.tariffs.length">
              <template v-for="(tariff, indexTariff) in tr.tariffs">
                <vs-tr :data="tariff" :key="`tariff-${tariff.id}`" class="tariff-row tariffs-table__row">
                  <vs-td>
                    <div class="tariff-row__name" @click="openEditTariffProperty('isNameEditOpen',tariff)">
                      <div class="flex items-center">
                        <feather-icon
                          title="Нет значения тарифа" icon="AlertTriangleIcon"
                          :svg-classes="['text-danger']" class="mr-2"
                          v-if="getCurrentValue(tariff.tarifs_value.filter(tariffValue => tariffValue.type_value === 0), tariff).value === '-' || String(getCurrentValue(tariff.tarifs_value.filter(tariffValue => tariffValue.type_value === 0), tariff).value) === '0'"
                        />
                        <div>
                            <span class="tariff-row__name--short">
                              {{ tariff.name }}
                              <span v-if="$can('rp.debug', 'read')" class="font-medium">#{{ tariff.id }}</span>
                            </span>
                          <span class="tariff-row__name--full" v-if="tariff.full_name">{{ tariff.full_name }}</span>
                        </div>
                      </div>
                    </div>
                  </vs-td>
                  <vs-td>
                    <div class="tariff-row__type">
                      <elsa-v-select
                        :options="tariffsTypes"
                        v-model="tariff.type_tarif"
                        label="name"
                        :reduce="item => item.tariffs_type"
                        :clearable="false"
                        :disabled="!$can('rp.tariffs', 'write')"
                        @input="saveTariff(tariff, {type_tarif: $event})"
                        styleType="noBorder"
                        :appendToBody="true"
                      />
                    </div>
                  </vs-td>
                  <vs-td>
                    <span class="tariff-row__value" @click="openEditTariffProperty('isValueEditOpen',tariff)">
                      {{
                        getCurrentValue(tariff.tarifs_value.filter(tariffValue => tariffValue.type_value === 0), tariff).value
                      }}
                    </span>
                  </vs-td>
                  <vs-td>
                    <div class="tariff-row__unit-id">
                      <elsa-v-select
                        :options="units"
                        v-model="tariff.unit_id"
                        label="name"
                        :reduce="item => item.id"
                        :clearable="false"
                        :disabled="!$can('rp.tariffs', 'write')"
                        @input="saveTariff(tariff, {unit_id: $event})"
                        styleType="noBorder"
                        :appendToBody="true"
                      />
                    </div>
                  </vs-td>
                  <vs-td style="width: 1%">
                    <div class="tariff-row__formula" @click="openEditTariffProperty('isFormulaEditOpen',tariff)">
                      <div class="formula tariff-formula" style="display: inline">
                        <span class="formula__item formula__unit">Знaчение</span>
                        <span class="formula__item formula__operator">*</span>
                        <span data-value="(" class="formula__item formula__bracket" style="display: inline">(</span>
                        <div
                          class="formula-text" style="display: inline"
                          v-html="$refs.formula.getHtml(tariff.formula, true)"
                        >
                        </div>
                        <span data-value=")" class="formula__item formula__bracket">)</span>
                      </div>
                    </div>
                  </vs-td>
                  <vs-td>
                     <span class="tariff-row__show-empty">
                      <vs-checkbox
                        :value="tariff.show_empty" @input="saveTariff(tariff, {show_empty: $event})"
                        :disabled="!$can('rp.tariffs', 'write')"
                      />
                    </span>

                  </vs-td>
                  <vs-td>
                    <span class="tariff-row__count-fine">
                      <vs-checkbox
                        :value="tariff.count_fine" @input="saveTariff(tariff, {count_fine: $event})"
                        :disabled="!$can('rp.tariffs', 'write')"
                      />
                    </span>
                  </vs-td>
                  <vs-td>
                    <span
                      class="tariff-row__extra-values"
                      @click="openEditTariffExtraValues(tariff)"
                    >
                      {{
                        tariff.tarifs_value.filter(tariffValue => tariffValue.type_value !== 0).length ? 'есть' : 'нет'
                      }}
                    </span>
                  </vs-td>
                  <vs-td>
                     <span class="tariff-row__show-empty">
                       <input
                         type="text" :value="tariff.position" :disabled="!$can('rp.tariffs', 'write')"
                         @keypress="$validateInput($event, 'uint')" @change="changeTariffPosition(tariff, $event)"
                         @keydown.enter="changeTariffPosition(tariff, $event)" class="tariff-row__position-input"
                       >
                      </span>
                  </vs-td>

                  <vs-td style="width: 1%">
                    <span class="tariff-row__buttons">
                      <feather-icon
                        icon="SettingsIcon" class="mr-1"
                        @click="openEditTariffProperty('isSettingsEditOpen',tariff)"
                      />
                      <feather-icon
                        icon="ArchiveIcon" @click="archiveTariff(tariff)"
                        v-if="$can('rp.tariffs', 'write')"
                      />
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </template>
            <vs-tr v-else class="tariff-row" :key="`empty-${indextr}`">
              <vs-td>
                <span class="tariff-row__name--hidden">Пустая группа</span>
                <span class="tariff-row__name tariff-row__name--center">Пустая группа</span>
              </vs-td>
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td />
              <vs-td style="width: 1%">
              </vs-td>
            </vs-tr>

          </template>
          </tbody>
        </template>
      </vs-table>
      <div v-else class="block-loading"></div>
    </div>

    <vs-popup
      title="Изменение названия" :active.sync="isNameEditOpen"
      v-if="currentEditingTariff && $can('rp.tariffs', 'write')"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <label for="tariff-name">Название</label>
          <vs-input
            class="w-full" id="tariff-name"
            v-model.trim="currentEditingTariff.name" autocomplete="off"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="tariff-full_name">Полное название</label>
          <vs-input
            class="w-full" id="tariff-full_name"
            v-model.trim="currentEditingTariff.full_name" autocomplete="off"
          />
        </div>
        <div class="vx-col w-full flex justify-center">
          <vs-button type="filled" color="success" @click.prevent="saveTariff(currentEditingTariff, {})" class="mt-4">
            Сохранить
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Изменение значения" :active.sync="isValueEditOpen" v-if="currentEditingTariff">
      <div class="vx-row">
        <div
          class="vx-col w-full mb-3 flex flex-wrap justify-between"
          v-for="(tariffValue, index) in currentEditingTariff.tarifs_value.filter(tariffValue => tariffValue.type_value === 0)"
          :key="`tariffValueWrapper${tariffValue.id}-${index}`"
        >
          <vs-input label="Основной тариф" class="mb-base mr-2" v-model="tariffValue.value" disabled />
          <div>
            <label :for="`tariffValue-startDate${index}`" class="vs-input--label">Действует c</label>
            <datepicker
              class="mb-base mr-2" format="MMMM yyyy" :ref="`tariffValue-startDate${index}`"
              v-model="tariffValue.start_date" disabled
              :id="`tariffValue${tariffValue.id}-startDate${index}`"
            />
          </div>
          <div>
            <label :for="`tariffValue-endDate${index}`" class="vs-input--label">Действует по</label>
            <datepicker
              class="mb-base" format="MMMM yyyy" :ref="`tariffValue-endDate${index}`"
              v-model="tariffValue.end_date" disabled :id="`tariffValue${tariffValue.id}-endDate${index}`"
            />
          </div>
        </div>
        <div
          class="vx-col w-full mb-3 flex flex-wrap justify-between items-center"
          v-for="(tariffValue, index) in currentEditingNewValues"
          :key="`tariffValueWrapper-${index}`"
        >
          <vs-input
            label="Основной тариф" class="mb-base mr-2 flex-1" v-model="tariffValue.value"
            :danger="tariffValue.isError" danger-text="Введите корректное значение"
            @keypress="$validateInput($event, 'udouble')"
            @input="tariffValue.isError = false"
          />
          <div class="flex-1">
            <label :for="`tariffValue-startDate${index}`" class="vs-input--label">Действует c</label>
            <datepicker
              class="mb-base mr-2" format="MMMM yyyy" :ref="`tariffValue-startDate${index}`"
              minimum-view="month"
              maximum-view="year" v-model="tariffValue.start_date" :id="`tariffValueNew-startDate${index}`"
            />
          </div>
          <div class="flex-1">
            <label :for="`tariffValue-endDate${index}`" class="vs-input--label">Действует по</label>
            <datepicker
              class="mb-base" format="MMMM yyyy" :ref="`tariffValue-endDate${index}`" minimum-view="month"
              maximum-view="year" v-model="tariffValue.end_date" :id="`tariffValueNew-endDate${index}`"
            />
          </div>
          <div>
            <feather-icon icon="TrashIcon" class="tariff--new-value__trash-icon" @click="deleteNewTariffValue(index)" />
          </div>
        </div>
        <div class="vx-col w-full flex justify-center">
          <vs-button type="flat" class="mr-2" @click="addNewTariffValue" v-if="$can('rp.tariffs', 'write')">
            Добавить
          </vs-button>
          <vs-button type="filled" color="success" @click="saveTariffsValues" v-if="$can('rp.tariffs', 'write')">
            Сохранить
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <formula-popup
      :active.sync="isFormulaEditOpen" :constants="constants" title="Редактирование формулы"
      @saveFormula="saveFormula"
      :formula="!currentEditingTariff ? JSON.stringify('{}') : currentEditingTariff.formula"
      @updateConstants="getConstants"
      :groups="constantsGroups"
      :key="JSON.stringify(constants)"
      ref="formula"
    />

    <vs-popup title="Доп. настройки тарифа" :active.sync="isSettingsEditOpen" v-if="currentEditingTariff">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <elsa-v-select
            :options="sortedGroups"
            v-model="currentEditingTariff.tarifs_group"
            label="name"
            :reduce="item => item.id"
            :clearable="false"
            :disabled="!$can('rp.tariffs', 'write')"
            styleType="largeLabel"
            htmlLabel="Группа"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="tariff-name">Позиция в группе</label>
          <vs-input
            class="mr-2 w-full" v-model.number="currentEditingTariff.position" type="number "
            :disabled="true || !$can('rp.tariffs', 'write')"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="tariff-name">Округление</label>
          <vs-input
            class="mr-2 w-full" v-model.number="currentEditingTariff.round_to" type="number"
            :disabled="!$can('rp.tariffs', 'write')" :danger="isRoundToError"
            danger-text="Заполните округление"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <vs-checkbox v-model="currentEditingTariff.is_utility" :disabled="!$can('rp.tariffs', 'write')">Коммунальный
          </vs-checkbox>
        </div>
        <div class="vx-col w-full mb-3">
          <vs-checkbox v-model="currentEditingTariff.is_housing" :disabled="!$can('rp.tariffs', 'write')">Жилищная
            услуга
          </vs-checkbox>
        </div>
        <div class="vx-col w-full mb-3">
          <vs-checkbox v-model="currentEditingTariff.is_target" :disabled="!$can('rp.tariffs', 'write')">Целевой взнос
          </vs-checkbox>
        </div>

        <div class="vx-col w-full mb-3">
          <label for="tariff-name">Месяц расчета</label>
          <datepicker
            class="w-full"
            v-model="editingTariffCalcMonth"
            format="MMMM yyyy"
            minimumView="month"
            maximumView="year"
            :disabled="!$can('rp.tariffs', 'write')"
            clear-button
          />
        </div>

        <div class="vx-col w-full mb-3">
          <vs-checkbox v-model="currentEditingTariff.can_be_privileged">
            Может облагаться льготами
          </vs-checkbox>
        </div>
        <div class="vx-col w-full mb-3">
          <vs-checkbox v-model="currentEditingTariff.can_be_boosted">
            С повышающим коэффициентом
          </vs-checkbox>
        </div>

        <div class="vx-col w-full flex justify-center" v-if="$can('rp.tariffs', 'write')">
          <vs-button type="filled" color="success" @click.prevent="saveSettings(currentEditingTariff)" class="mt-4">
            Сохранить
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Настройки группы" :active.sync="isSettingsGroupOpen" v-if="currentEditingGroup">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <label for="tariff-group-name">Название</label>
          <vs-input
            class="w-full" id="tariff-group-name"
            v-model.trim="currentEditingGroup.name" autocomplete="off"
          />
        </div>

        <div class="vx-col w-full mb-3">
          <label for="tariff-group-position">Позиция</label>
          <vs-input
            class="w-full" id="tariff-group-position" type="number"
            v-model.number="currentEditingGroup.position" autocomplete="off"
            disabled
          />
        </div>

        <div class="vx-col w-full flex justify-center">
          <vs-button type="flat" color="danger" @click.prevent="deleteGroup" class="mt-4">
            Удалить
          </vs-button>
          <vs-button type="filled" color="success" @click.prevent="saveEditGroup" class="mt-4">
            Сохранить
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Добавление группы" :active.sync="isGroupAddOpen" v-if="newGroup">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <label for="new-group-name">Название</label>
          <vs-input
            class="w-full" id="new-group-name"
            v-model.trim="newGroup.name" autocomplete="off"
          />
        </div>

        <div class="vx-col w-full flex justify-center">
          <vs-button type="filled" color="success" @click.prevent="addNewGroup" class="mt-4">
            Добавить
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Добавление тарифа" :active.sync="isTariffAddOpen" v-if="newTariff">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <elsa-v-select
            :options="sortedGroups"
            v-model="newTariff.tarifs_group"
            label="name"
            :reduce="item => item.id"
            :clearable="false"
            styleType="largeLabel"
            htmlLabel="Группа"
            :danger="newTariffErrors.group"
            danger-text="Выберите группу"
            @input="newTariffErrors.group = false"
            :appendToBody="true"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <elsa-v-select
            :options="tariffsTypes"
            v-model="newTariff.type_tarif"
            label="name"
            :reduce="item => item.tariffs_type"
            :clearable="false"
            styleType="largeLabel"
            htmlLabel="Тип"
            :danger="newTariffErrors.group"
            danger-text="Выберите тип"
            @input="newTariffErrors.group = false"
            :appendToBody="true"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="new-tariff-name">Название</label>
          <vs-input
            class="w-full" id="new-tariff-name"
            v-model.trim="newTariff.name" autocomplete="off"
            :danger="newTariffErrors.name" danger-text="Введите название" @input="newTariffErrors.name = false"
          />
        </div>
        <div class="vx-col w-full mb-3">
          <label for="new-tariff-full_name">Полное название</label>
          <vs-input
            class="w-full" id="new-tariff-full_name"
            v-model.trim="newTariff.full_name" autocomplete="off"
          />
        </div>

        <div class="vx-col w-full mb-3">
          <vs-checkbox v-model="newTariff.can_be_privileged">
            Может облагаться льготами
          </vs-checkbox>
        </div>

        <div class="vx-col w-full flex justify-center">
          <vs-button type="filled" color="success" @click.prevent="addNewTariff" class="mt-4">
            Добавить
          </vs-button>
        </div>
      </div>
    </vs-popup>

  </vx-card>
</template>

<script>
import TabsHeader         from "@/components/TabsHeader";
import HeatSeasonSettings from "@/components/HeatSeasonSettings";
import moment             from 'moment';
import listInput          from "@/components/calculated-program/tariffs/TariffExtraConditionsListInput";
import FormulaPopup       from "@/components/calculated-program/tariffs/FormulaPopup";

const KVM_UNIT = 4;

export default {
  name:       "Tariffs",
  components: { HeatSeasonSettings, TabsHeader, listInput, FormulaPopup },
  data() {
    return {
      units:                   [],
      tariffGroups:            [],
      currentEditingTariff:    null,
      isNameEditOpen:          false,
      isValueEditOpen:         false,
      isFormulaEditOpen:       false,
      isSettingsEditOpen:      false,
      needUpdateFormula:       false,
      currentEditingNewValues: [],
      isSettingsGroupOpen:     false,
      currentEditingGroup:     null,
      isLoading:               false,
      isGroupAddOpen:          false,
      newGroup:                {
        name: "",
      },
      isTariffAddOpen:         false,
      newTariff:               {
        name:              "",
        full_name:         "",
        tarifs_group:      null,
        type_tarif:        null,
        can_be_privileged: false,
      },
      newTariffErrors:         {
        name:       false,
        group:      false,
        type_tarif: false,
      },
      constants:               [],
      constantsGroups:         [],
      apartments:              [],
      apartmentsLoader:        null,
      tariffsTypes:            [],
      isRoundToError:          false,
    };
  },
  computed: {
    selectedApartmentType() {
      return +this.$route.params.apartmentsType;
    },
    selectedMonth:          {
      get() {
        return this.$store.getters['appUser/selectedDate'];
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },
    editingTariffCalcMonth: {
      get() {
        return this.currentEditingTariff.calc_month;
      },
      set( value ) {
        this.currentEditingTariff.calc_month = value ? moment(value).format('YYYY-MM') : null;
      },
    },
    apartmentsTypes() {
      return this.$store.getters['appUser/apartmentsTypes'];
    },
    availableTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    sortedGroups() {
      let tariffs = this.tariffGroups;
      tariffs = tariffs.map(group => {
        if (group.tariffs) {
          group.tariffs.sort(( a, b ) => a.position - b.position);
        }
        return group;
      }).sort(( a, b ) => a.position - b.position);
      return tariffs;
    },
  },
  methods:  {
    resetNewGroup() {
      this.newGroup.name = "";
    },
    async addNewGroup() {
      try {
        let body = Object.assign({}, this.newGroup);
        body.position = this.sortedGroups[this.sortedGroups.length - 1] ? this.sortedGroups[this.sortedGroups.length - 1].position + 1 : 0;
        body.buildings_id = this.selectedHouseId;
        body.management_companies_id = this.$store.getters['appUser/management_companies_id'];
        let { data } = await this.$http.post('tarif_group', body);
        this.getTariffs();
        this.isGroupAddOpen = false;
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    resetNewTariff() {
      this.newTariff.name = '';
      this.newTariff.full_name = '';
      this.newTariff.tarifs_group = null;
      this.newTariff.type_tarif = null;
      this.newTariff.can_be_privileged = false;

      this.newTariffErrors.name = false;
      this.newTariffErrors.group = false;
      this.newTariffErrors.type_tarif = false;
    },
    async addNewTariff() {
      if (this.newTariff.tarifs_group === null) {
        this.newTariffErrors.group = true;
      }

      if (this.newTariff.type_tarif === null) {
        this.newTariffErrors.type_tarif = true;
      }

      if (!this.newTariff.name.trim().length) {
        this.newTariffErrors.name = true;
      }

      if (this.newTariffErrors.group || this.newTariffErrors.name || this.newTariffErrors.type_tarif) {
        return false;
      }

      try {
        let body = Object.assign({}, this.newTariff, {
          buildings_id:            this.selectedHouseId,
          management_companies_id: this.$store.getters['appUser/management_companies_id'],
          apartments_type:         this.selectedApartmentType,
        });
        let typeTariff = this.getTariffTypeByTypeId(body.type_tarif);
        body.formula = typeTariff.default_formula ? typeTariff.default_formula : null;

        let group = this.sortedGroups.find(group => group.id === body.tarifs_group);
        body.position = group.tariffs[group.tariffs.length - 1] ? group.tariffs[group.tariffs.length - 1].position + 1 : 0;
        let { data } = await this.$http.post('tarifs', body);
        this.getTariffs();
        this.isTariffAddOpen = false;
      } catch (e) {
        console.error(e);
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }

    },
    addNewTariffValue() {
      this.currentEditingNewValues.push({
        tarifs_id:    this.currentEditingTariff.id,
        buildings_id: this.currentEditingTariff.buildings_id,
        isError:      false,
        value:        null,
        start_date:   new Date(),
        end_date:     null,
      });
    },
    async saveTariffsValues() {
      this.currentEditingNewValues = this.currentEditingNewValues.map(tariffValue => {
        const newValue = tariffValue.value === null ? null : Number(tariffValue.value.replace(/,/g, '.'));
        if (newValue === null || isNaN(newValue)) {
          tariffValue.isError = true;
        } else {
          tariffValue.value = newValue;
        }
        return tariffValue;
      });

      let hasError = false;

      this.currentEditingNewValues.forEach(tariffValue => {
        if (tariffValue.isError) hasError = true;
      });

      if (hasError) return false;

      let moment = require('moment');

      try {
        for await (let tariffValue of this.currentEditingNewValues) {
          let body = Object.assign({}, tariffValue);
          body.start_date = this.$options.filters.moment(moment(body.start_date).startOf('month').toDate(), "YYYY-MM-DD");
          body.end_date = body.end_date ? this.$options.filters.moment(moment(body.end_date).endOf('month').toDate(), "YYYY-MM-DD") : null;
          await this.$http.post('tarif_value', body);
        }

        if (this.currentEditingNewValues.length) {
          await this.updateTariff(this.currentEditingNewValues[0].tarifs_id, this.currentEditingNewValues[0].buildings_id);
        }
        this.currentEditingNewValues = [];
        this.closeAllModals();
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    deleteNewTariffValue( index ) {
      this.currentEditingNewValues.splice(index, 1);
    },

    closeAllModals() {
      this.isNameEditOpen = false;
      this.isValueEditOpen = false;
      this.isFormulaEditOpen = false;
      this.isSettingsEditOpen = false;
    },
    async updateTariff( id, buildingsId = null ) {
      return new Promise(async ( resolve, reject ) => {
        try {
          buildingsId = buildingsId ? buildingsId : this.selectedHouseId;
          let { data: updatedTariff } = await this.$http.get('tarifs?id=' + id + '&buildings_id=' + buildingsId);

          if (updatedTariff.length) {
            updatedTariff = updatedTariff[0];
          }
          let groupIndex = this.sortedGroups.findIndex(group => group.id === updatedTariff.tarifs_group.id);
          if (groupIndex !== -1) {
            let tariffToUpdateIndex = this.sortedGroups[groupIndex].tariffs.findIndex(tariffInGroup => tariffInGroup.id === updatedTariff.id);
            if (tariffToUpdateIndex !== -1) {
              this.$set(this.sortedGroups[groupIndex].tariffs, tariffToUpdateIndex, updatedTariff);
            }
          }
          resolve();
        } catch (e) {
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
            } else {
              this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
            }
          } else {
            this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
          }
          reject(e);
        }
      });
    },
    async saveTariff( tariff, newValues ) {
      return new Promise(async ( resolve, reject ) => {
        try {
          let body = Object.assign({}, tariff, newValues);
          if (!body.id) return false;
          body.tarifs_group = typeof tariff.tarifs_group === typeof {} ? tariff.tarifs_group.id : tariff.tarifs_group;
          body.is_on_devices = body.can_be_boosted;
          await this.$http.put('tarifs/' + body.id, body);
          this.updateTariff(body.id, body.buildings_id);
          this.closeAllModals();
          resolve();
        } catch (e) {
          if (e.response) {
            if (e.response.status === 403) {
              this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
            } else {
              this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
            }
          } else {
            this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
          }
          this.closeAllModals();
          reject();
        }
      });
    },
    async saveSettings( tariff ) {
      let roundTo = String(tariff.round_to);

      if (!roundTo.length || isNaN(Number(roundTo))) {
        this.isRoundToError = true;
        return false;
      }


      await this.saveTariff(tariff, {});
      this.getTariffs();
    },
    async saveFormula( formula ) {
      await this.saveTariff(this.currentEditingTariff, { formula: formula });
      this.getTariffs();
    },
    openEditTariffExtraValues( tariff ) {
      this.$modal.open({
        size:           'xl',
        title:          'Изменение доп. условий',
        component:      () => import('@/components/TariffsExtraValuesPopup'),
        componentProps: {
          tariff,
          apartmentsLoader: this.apartmentsLoader,
        },
      }, { closeOnBackdrop: false }).result.then(( somethingChanged ) => {
        if (somethingChanged) this.updateTariff(tariff.id, tariff.buildings_id);
      });
    },
    openEditTariffProperty( property, tariff ) {
      this.isRoundToError = false;
      this.currentEditingTariff = Object.assign({}, tariff);
      this.currentEditingTariff.tarifs_group = this.currentEditingTariff.tarifs_group.id;
      this[property] = true;
    },
    archiveTariff( tariff ) {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите переместить тариф в архив?',
        acceptText: 'В архив',
        cancelText: 'Отменить',
        accept:     async () => {
          await this.saveTariff(tariff, { is_archive: true });
          this.getTariffs();
        },
      });
    },
    async getTariffs( withLoading = false ) {
      if (withLoading) {
        this.isLoading = true;
      }

      try {
        let { data: groups } = await this.$http.get('tarif_group?buildings_id=' + this.selectedHouseId);
        groups.map(group => {
          this.$set(group, 'tariffs', []);
          return group;
        });
        let { data: tariffs } = await this.$http.get('tarifs', {
          params: {
            buildings_id:    this.selectedHouseId,
            apartments_type: this.selectedApartmentType,
          },
        });

        tariffs.sort(( a, b ) => a.position - b.position);
        for (let i = 0; i < tariffs.length; i++) {
          let tariff = tariffs[i];
          if (tariff.tarifs_group) {
            let groupIndex = groups.findIndex(group => group.id === tariff.tarifs_group.id);
            if (groupIndex !== -1) {
              groups[groupIndex].tariffs.push(tariff);
            }
          }
        }
        this.tariffGroups = groups;
      } catch (e) {
        this.tariffGroups = [];
      } finally {
        if (withLoading) {
          this.$nextTick(() => {
            this.isLoading = false;
          });
        }
      }
    },
    async getUnits() {
      try {
        let { data } = await this.$http.get('units');
        this.units = data;
      } catch (e) {
        this.units = [
          {
            "id":   KVM_UNIT,
            "name": "Кв.м",
          },
        ];
      }
    },
    openEditGroup( group ) {
      this.currentEditingGroup = Object.assign({}, group);
      this.isSettingsGroupOpen = true;
    },
    async saveEditGroup() {
      try {
        let body = Object.assign({}, this.currentEditingGroup);
        delete body.tariffs;
        body.buildings_id = this.selectedHouseId;
        await this.$http.put('tarif_group/' + body.id, body);
        this.getTariffs();
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },
    deleteGroup() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить группу?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     async () => {
          try {
            await this.$http.delete('tarif_group/' + this.currentEditingGroup.id, { params: { buildings_id: this.selectedHouseId } });
            this.isSettingsGroupOpen = false;
            this.getTariffs();
          } catch (e) {
            if (e.response) {
              if (e.response.status === 403) {
                this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
              } else {
                this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
              }
            } else {
              this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
            }
          }
        },
      });
    },
    async getData() {
      this.getUnits();
      await this.getConstants();
    },
    getCurrentValue( values, tariff ) {
      let moment = require('moment');
      let currentDate = moment(this.selectedMonth);
      if (tariff.is_utility) {
        currentDate = moment(this.selectedMonth).subtract(1, 'month');
      }
      currentDate = currentDate.toDate();

      let startOfMonth = new Date(currentDate);
      let endOfMonth = moment(currentDate).endOf('month').endOf('day').toDate();

      let currentValues = [];

      values.forEach(value => {
        let startValueDate = moment(new Date(this.$parseDateFromString(value.start_date))).startOf('month').startOf('day').toDate();
        let endValueDate = moment(new Date(this.$parseDateFromString(value.end_date))).endOf('month').endOf('day').toDate();

        if (startValueDate <= startOfMonth && endValueDate >= endOfMonth) {
          currentValues.push(value);
        }
      });
      return currentValues.length ? currentValues.pop() : { value: '-' };
    },
    async getConstantsGroups() {
      return new Promise(async ( resolve, reject ) => {
        try {
          let { data } = await this.$http.get('constants_types', {
            params: {
              buildings_id: this.selectedHouseId,
            },
          });

          this.constantsGroups = data;
          resolve();
        } catch (e) {
          this.constantsGroups = [];
          resolve();
        }
      });
    },
    async getConstants() {
      return new Promise(async ( resolve, reject ) => {
        try {
          await this.getConstantsGroups();
          let { data } = await this.$http.get('constants', {
            params: {
              buildings_id: this.selectedHouseId,
            },
          });

          this.constants = data;

          resolve();
        } catch (e) {
          this.constants = [];
          reject();
        }
      });
    },
    getAparts() {
      this.apartmentsLoader = this.$http.get(`all_aparts?buildings_id=${this.selectedHouseId}`);
      this.apartmentsLoader.then(( { data } ) => {
        this.apartments = data.filter(apartment => apartment.account_number);
      });
    },
    async getTariffsTypes() {
      try {
        let { data } = await this.$http.get('tarif_types', {
          params: {
            buildings_id: this.selectedHouseId,
          },
        });
        this.tariffsTypes = data;
      } catch (e) {
        this.tariffsTypes = [];
      }
    },
    getTariffTypeByTypeId( tariffs_type ) {
      return this.tariffsTypes.find(type => type.tariffs_type === tariffs_type) || { id: null, default_formula: null };
    },
    changeTariffPosition( tariff, event ) {
      this.saveTariff(tariff, { position: Number(event.target.value) });
    },
    async changeGroupPosition( group, event ) {
      let position = Number(event.target.value);
      let oldPosition = group.position;

      try {
        let body = Object.assign({}, group, { position: position });
        delete body.tariffs;
        body.buildings_id = this.selectedHouseId;
        await this.$http.put('tarif_group/' + body.id, body);
        this.isSettingsGroupOpen = false;
        this.getTariffs();
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },

    checkApartmentType() {
      const selectedApartmentType = +this.$route.params.apartmentsType;
      let newApartmentType = null;
      if (Number.isNaN(selectedApartmentType)) {
        newApartmentType = this.availableTypes[0].id;
      } else {
        const selectedType = this.availableTypes.find(type => type.id === selectedApartmentType);
        if (!selectedType) newApartmentType = this.availableTypes[0].id;
      }

      if (newApartmentType !== null) {
        this.$router.replace({ params: { apartmentsType: newApartmentType } });
      }
    },

    onSelectApartmentType( apartmentsType ) {
      this.$router.replace({ params: { apartmentsType } });
    },
  },
  created() {
    this.getTariffsTypes();
  },
  mounted() {
    this.selectedMonth = new Date();

    this.checkApartmentType();

    this.getAparts();
    this.getData();
    this.getTariffs(true);
  },
  watch: {
    isGroupAddOpen() {
      this.resetNewGroup();
    },
    isTariffAddOpen() {
      this.resetNewTariff();
    },
    selectedHouseId() {
      this.checkApartmentType();

      this.getAparts();
      this.getTariffs(true);
      this.getConstants();
      this.getTariffsTypes();
    },
    selectedApartmentType() {
      this.getTariffs(true);
    },
    isValueEditOpen() {
      this.currentEditingNewValues = [];
    },
  },
};
</script>

<style lang="scss">
.tariffs-card {
  .vx-card__body {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  &__tabs {
    .con-ul-tabs {
      margin: 0 10px
    }
  }
}


.tariffs-table {

  thead {
    th {
      border: 1px solid rgba(0, 0, 0, .2);
      padding-top: .5rem !important;
      padding-bottom: .5rem !important;
    }
  }

  .vs-con-tbody {
    border: none;
  }

  &__group-row {
    background: #f2f2f2 !important;
    border-top: 1px solid rgba(0, 0, 0, .2);
    border-bottom: 1px solid rgba(0, 0, 0, .2);

    td {
      padding: 0 !important;

      &:first-child {
        border-left: 1px solid rgba(0, 0, 0, .2);
      }

      &:last-child {
        border-right: 1px solid rgba(0, 0, 0, .2);
      }
    }

    .tariff-row__name {
      font-weight: 500;
      padding: 5px;

      &:not(.tariff-row__name--hidden) {
      }
    }
  }

  &__row {
    td {
      border: 1px solid rgba(0, 0, 0, .2) !important;
      padding: 0 !important;
    }
  }

  tr {
    &:hover {
      transform: none !important;
    }
  }
}


.tariff-row {
  td {
    &:first-child {
      border-left: 1px solid rgba(0, 0, 0, .2);
    }

    &:last-child {
      border-right: 1px solid rgba(0, 0, 0, .2);
    }
  }

  &__position-input {
    padding: 2px 5px;
    line-height: 1;
    font-size: 1rem;
    border: 1px solid rgba(0, 0, 0, .2);
    border-radius: 2px;
    width: 50px;
    font-weight: 400;
    color: #626262;

    input {
      padding: 5px 10px !important;
    }
  }

  &__name {
    padding: 0 10px 0;
    white-space: nowrap;

    &--hidden {
      opacity: 0;
    }

    &--center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    &--full {
      display: block;
      font-size: .85rem;
    }
  }

  &__formula {
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-all;
    white-space: nowrap;
    min-width: 400px;
    width: 30vw;
    position: relative;
    text-align: center;
    padding: 5px 0;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 10px;
      background: #fff;
    }

    .tariff-formula {
      overflow: hidden;
      padding: 0 10px;
    }
  }

  &__unit-id {
    width: 100px;
  }

  &__value {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__show-empty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__count-fine {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__extra-values {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
  }

  &__type {
    width: 200px;
  }
}

.formula {
  &__item {
    display: inline;
    vertical-align: middle;
    padding: 2px 5px;
    word-break: break-all;
    margin: 2px;
    background-color: #f2f2f2;
    border-radius: 999px;
    position: relative;
    overflow: hidden;
    font-size: .9rem;
    white-space: nowrap;
    border: 1px solid rgba(0, 0, 0, .2);
    line-height: 1;
  }

  &__operator {
    color: #f6474e;
    background-color: transparent;
    border: none;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    padding-left: 3px;
    padding-right: 3px;
    font-size: 1.25rem;
  }

  &__bracket {
    background-color: transparent;
    border: none;
    color: #12c2b7;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    padding-left: 1px;
    padding-right: 1px;
    font-size: 1.5rem;
  }
}

.tariff--new-value__trash-icon {
  svg {
    width: 16px;
    height: 16px;
    color: rgba(var(--vs-danger), 1);
    cursor: pointer;
  }
}

.extra-values-popup {
  .vs-popup {
    width: 1150px;
  }

  &__type {
    width: 160px;
  }

  &__select {
    width: 142px;
  }
}

.block-loading {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(var(--vs-primary), 1);
    border-radius: 50%;
    border-top-color: #eee;
    animation: spin 1s ease-in-out infinite;
  }
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

.header-datepicker {
  input {
    max-width: 120px;
  }
}

.tariff-header__button {
  &.vs-button {
    padding: .5rem .7rem !important;
  }
}

.tariffs {
  $this: &;

  padding: 10px;

  &__tabs {
    margin-bottom: .5em;
  }
}

</style>
